import React from 'react'
import { useRecJobsContext } from '../../RecommendedJobsProvider'
import LoadingPlaceholder from './Loading'
import NoPreferencesSetPlaceholder from './NoPreferencesSet'
import RecommendedJobs from './RecommendedJobs'

export const RecommendedJobsArea = ({ loading, data, error }) => {
  const { jobSearchStatus, recommendedJobs } = data || {}

  if (loading) return <LoadingPlaceholder />
  if (!recommendedJobs) return <NoPreferencesSetPlaceholder />
  if (error) return 'Something went wrong.'

  return (
    jobSearchStatus
      ? <RecommendedJobs recommendedJobs={recommendedJobs || []} />
      : <NoPreferencesSetPlaceholder />
  )
}

export default () => {
  const { loading, data, error } = useRecJobsContext()
  return <RecommendedJobsArea {...{ loading, data, error }} />
}
